module.exports = __webpack_public_path__ + "assets/img/email-788f04a1.png";